import qs from 'query-string'
import { useQuery } from '@tanstack/react-query'

import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'
import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'

import type { GapReport } from '@pepper/utils/src/types/seo'

type ReturnType = {
  reports?: {
    data: GapReport[]
    has_more: boolean
    total_records: number
  }
  isLoading: boolean
  isFetching: boolean
  refetch: () => void
  error: unknown
}

const handleApiRequest = async (
  companyId: string,
  page: number,
  limit: number,
  pageUrl: string
) => {
  try {
    const queryParamsData = qs.stringify(
      {
        limit,
        page,
        pageUrl
      },
      { skipNull: true, skipEmptyString: true }
    )
    const response = await axios.get(
      `${SEO_SERVICE_BASE_URL}/companies/${companyId}/content-gap/?${queryParamsData}`
    )

    return response.data
  } catch (error) {
    return extract.error(error)
  }
}

export const useGetGapReports = ({
  companyId,
  isEnabled = false,
  page = 1,
  limit = 8,
  pageUrl,
  refetchInterval = false
}: {
  companyId: string
  isEnabled?: boolean
  page?: number
  limit?: number
  pageUrl: string
  refetchInterval?: number | false
}): ReturnType => {
  const {
    data: response,
    isLoading,
    isFetching,
    error,
    refetch
  } = useQuery({
    queryFn: () => handleApiRequest(companyId, page, limit, pageUrl),
    queryKey: ['content-gap-url-refresh-reports', companyId, page, pageUrl],
    enabled: isEnabled,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    refetchInterval
  })

  return {
    reports: response,
    isLoading,
    isFetching,
    error,
    refetch
  }
}
